import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import getMovimentos, { getAllMovimentos } from "../queries/getMovimentos";

export default function useMovimentos(dataSearch?: any, page: number = 1) {
  const { search, numeroNF, movimentoTipo } = dataSearch;
  const resultQuery = useQuery(
    [`${URLS.MOVIMENTOS_API}`, {
      params: { search, numeroNF, movimentoTipo, page }
    }],
    () => getMovimentos(search, numeroNF, movimentoTipo, page),
    {
      enabled: !!page,
    }
  );

  return resultQuery;
}


//Retorna todos os dados sem paginar
export function useAllMovimentos() {
  const resultQuery = useQuery([URLS.MOVIMENTOS_API],
    () => getAllMovimentos(),
    {
      cacheTime: 0,
      onSuccess: (data) => {
        return data;
      },
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return resultQuery;
}
